import React from "react";
import "./OurPortfolio.css";

const OurPortfolio = () => {
  return (
    <>
      <section style={{ backgroundColor: "#1a1a1a" }}>
        <div className="container py-5">
          {/* Section Title */}
          <div className="row mb-5">
            <div className="col-12">
              <h2 className="display-4 text-white fw-normal">Our Portfolio</h2>
            </div>
          </div>

          {/* Portfolio Grid */}
          <div className="row g-4">
            {/* Knightsbridge Townhouse - Top Left */}
            <div className="col-md-6 col-lg-4">
              <div className="portfolio-item" style={{ height: "500px" }}>
                <div
                  className="item-1"
                  style={{
                    // background:
                    //   "linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%)",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      textAlign: "center",
                      color: "#666",
                    }}
                  >
                    {/* <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>
                      🏠
                    </div>
                    <div>Modern Living Room</div> */}
                  </div>
                  <div className="portfolio-overlay">
                    <h5 className="mb-1">Green Powder</h5>
                    <p className="mb-0 text-white-50">Coated Fence Panels</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Mile End Townhouse - Top Right */}
            <div className="col-md-6 col-lg-4">
              <div className="portfolio-item" style={{ height: "500px" }}>
                <div
                  className="item-2"
                  style={{
                    // background:
                    //   "linear-gradient(135deg, #d4905a 0%, #b87844 100%)",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      textAlign: "center",
                      color: "white",
                    }}
                  >
                    {/* <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>
                      🚪
                    </div>
                    <div>Entrance Hall</div> */}
                  </div>
                  <div className="portfolio-overlay">
                    <h5 className="mb-1">
                      Next in Our Range of Fencing Solutions
                    </h5>
                    {/* <p className="mb-0 text-white-50">Renovation</p> */}
                  </div>
                </div>
              </div>
            </div>

            {/* Regency Terrace - Large Right */}
            <div className="col-lg-4">
              <div className="portfolio-item" style={{ height: "500px" }}>
                <div
                  className="item-3"
                  style={{
                    // background:
                    //   "linear-gradient(135deg, #f8f8f8 0%, #e0e0e0 100%)",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      textAlign: "center",
                      color: "#666",
                    }}
                  >
                    {/* <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>
                      🏢
                    </div>
                    <div>Modern Interior Design</div> */}
                  </div>
                  <div className="portfolio-overlay">
                    <h5 className="mb-1">Galvanized Steel</h5>
                    <p className="mb-0 text-white-50">Fence Panels</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Trejo's Tacos - Bottom Left Large */}
            <div className="col-md-8 col-lg-4 position-relative">
              <div className="portfolio-item" style={{ height: "500px" }}>
                <div
                  className="item-4"
                  style={{
                    // background:
                    //   "linear-gradient(135deg, #f4f1e8 0%, #e8dcc0 100%)",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      textAlign: "center",
                      color: "#8b4513",
                    }}
                  >
                    {/* <div style={{ fontSize: "2.5rem", marginBottom: "0.5rem" }}>
                      🌮
                    </div>
                    <div>Restaurant Interior</div> */}
                  </div>
                  <div className="portfolio-overlay">
                    <h5 className="mb-1">Mandatory</h5>
                    <p className="mb-0 text-white-50">Construction Site Security</p>
                  </div>
                </div>
              </div>
            </div>

            {/* House Renovation in Kilburn - Bottom Center */}
            <div className="col-md-4 col-lg-4">
              <div className="portfolio-item" style={{ height: "500px" }}>
                <div
                  className="item-5"
                  style={{
                    // background:
                    //   "linear-gradient(135deg, #2c3e50 0%, #34495e 100%)",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      textAlign: "center",
                      color: "white",
                    }}
                  >
                    {/* <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>
                      🏗️
                    </div>
                    <div>Extension Project</div> */}
                  </div>
                  <div className="portfolio-overlay">
                    <h5 className="mb-1">Security First</h5>
                    {/* <p className="mb-0 text-white-50">Kilburn, London</p> */}
                  </div>
                </div>
              </div>
            </div>

            {/* Residential Building - Bottom Right */}
            <div className="col-md-12 col-lg-4">
              <div className="portfolio-item" style={{ height: "500px" }}>
                <div
                  className="item-6"
                  style={{
                    // background:
                    //   "linear-gradient(135deg, #34495e 0%, #2c3e50 100%)",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      textAlign: "center",
                      color: "white",
                    }}
                  >
                    {/* <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>
                      🏘️
                    </div>
                    <div>Modern Architecture</div> */}
                  </div>
                  <div className="portfolio-overlay">
                    <h5 className="mb-1">Events &</h5>
                    <p className="mb-0 text-white-50">
                      Residential Security
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default OurPortfolio;
